import { IModelSpot, IOxygenModel } from './oxygenModel'
import { oxygenModel } from './oxygenModel-sidecar'

export function run(model: IOxygenModel) {
  for (let j = 0; j < model.height; j++) {
    for (let i = 0; i < model.width; i++) {
      let spot = oxygenModel.getTileUnsafe(model, i, j)
      spot.buildingNum = -1
    }
  }

  let buildingIdx = 100

  let flood = (spot: IModelSpot, oi: number, oj: number) => {
    let n = oxygenModel.getTile(model, spot.i + oi, spot.j + oj)
    if (n) {
      if (n.buildingNum === -1) {
        if (!n.isHull) {
          n.buildingNum = spot.buildingNum
          flood(n, 1, 0)
          flood(n, 0, 1)
          flood(n, -1, 0)
          flood(n, 0, -1)
        }
      }
    }
  }

  // Flood fill space
  for (let j = 0; j < model.height; j++) {
    for (let i = 0; i < model.width; i++) {
      let spot = oxygenModel.getTileUnsafe(model, i, j)
      if (spot.buildingNum === -1) {
        if (spot.isSpace) {
          spot.buildingNum = 0
          flood(spot, 1, 0)
          flood(spot, 0, 1)
          flood(spot, -1, 0)
          flood(spot, 0, -1)
        }
      }
    }
  }
  // Flood fill buildings
  for (let j = 0; j < model.height; j++) {
    for (let i = 0; i < model.width; i++) {
      let spot = oxygenModel.getTileUnsafe(model, i, j)
      if (spot.buildingNum === -1) {
        if (!spot.isSpace) {
          if (!spot.isHull) {
            buildingIdx++
            spot.buildingNum = buildingIdx
            flood(spot, 1, 0)
            flood(spot, 0, 1)
            flood(spot, -1, 0)
            flood(spot, 0, -1)
          }
        }
      }
    }
  }
}
